export default (base64: string) =>{
    return base64.substring("data:image/".length, base64.indexOf(";base64")) || "jpeg"
}